import {httpPost, httpGet, httpDownloadFile} from '../api/http_caller.js'
import {calcNumeroRepertorioCompleto, calcNumeroRaccoltaCompleto} from '../filters/pratica.filter.js'
import {cloneDeep} from 'lodash'
import {useRoute, useRouter} from "vue-router";
import {usePraticaStore} from "../store/crm.store";

export function usePratica(dataRef) {
  const praticaStore = usePraticaStore();
  const route = useRoute()
  const router = useRouter()

  /**
   * Recupero la lista delle nature atto
   * @returns {Promise<void>}
   */
  async function getNaturaAtti() {
    let getAreaAtti = await httpGet('Pratica', 'getAtti', null, {messages: false, loading: false})
    if (getAreaAtti && getAreaAtti.esito === 'ok') {
      let optionsObj = [];
      let optionsChildrenObj = [];
      optionsChildrenObj[0] = [];
      let refs = {refName: 'descrizione', refValue: 'area_atto'};
      let childrenRefs = {ref: 'natura_atti', idRef: 'area_atto', refs: {refName: 'descrizione', refValue: 'atto_id'}};
      for (const [key, value] of Object.entries(getAreaAtti)) {
        if (typeof value === 'object') {
          optionsObj.push({name: value[refs.refName], value: value[refs.refValue], children: []});
          if (childrenRefs && value[childrenRefs.ref]) {
            optionsChildrenObj[value[childrenRefs.idRef]] = [];
            for (const [childrenKey, childrenValue] of Object.entries(value[childrenRefs.ref])) {
              optionsChildrenObj[value[childrenRefs.idRef]].push({
                name: childrenValue[childrenRefs.refs.refName],
                value: childrenValue[childrenRefs.refs.refValue],
                parentAtto: value[childrenRefs.ref]
              })

              if(!optionsChildrenObj[value[childrenRefs.idRef]]) {
                optionsChildrenObj[value[childrenRefs.idRef]] = {};
              }

              optionsObj[optionsObj.length - 1].children.push(childrenValue[childrenRefs.refs.refValue]);
            }
          }
        }
      }

      return {
        attiNaturaAtti: optionsObj,
        naturaAtti: optionsChildrenObj
      }
    }
  }

  /**
   * TODO: togliere dataRef
   * Popola e calcola i dati del dettaglio della pratica
   * @returns {Promise<void>}
   */
  async function popolaDettagliPratica(praticaDettagli, praticaDettagliData, attiNaturaAtti) {
    for (let praticaKey in dataRef.praticaDettagli.value) {
      switch (praticaKey) {
        case "atto_id":
          dataRef.praticaDettagli.value['natura_atto_id'].value = dataRef.praticaDettagliData.value[praticaKey];
          for (let i = 0; i < attiNaturaAtti.value.length; i++) {
            if (attiNaturaAtti.value[i] && attiNaturaAtti.value[i] != undefined && attiNaturaAtti.value[i]['children']) {
              for (let k = 0; k < attiNaturaAtti.value[i]['children'].length; k++) {
                if (attiNaturaAtti.value[i]['children'][k] == dataRef.praticaDettagliData.value[praticaKey]) {
                  dataRef.praticaDettagli.value['area_atto_id'].value = attiNaturaAtti.value[i].value;
                  break;
                }
              }
            }
          }
          break;

        case "data_ora_stipula":
          if (dataRef.praticaDettagliData.value[praticaKey]) {
            let data_ora_stipula = dataRef.praticaDettagliData.value[praticaKey].split(' ');

            dataRef.praticaDettagli.value['data_stipula'].value = data_ora_stipula[0];
            dataRef.praticaDettagli.value['ora_stipula'].value = data_ora_stipula[1];
          }
          break;

        case "estremi_r_data":
          if (dataRef.praticaDettagliData.value[praticaKey]) {
            let estremi_r_data = dataRef.praticaDettagliData.value[praticaKey].split(' ');

            dataRef.praticaDettagli.value['estremi_r_data_no_time'].value = estremi_r_data[0];
          }
          break;

        case "data_creazione":
          let data_creazione = dataRef.praticaDettagliData.value[praticaKey].split(' ');
          dataRef.praticaDettagli.value['data_creazione'].value = data_creazione[0];
          break;

        case "numero_repertorio_completo":
          dataRef.praticaDettagli.value['numero_repertorio_completo'].value = calcNumeroRepertorioCompleto(dataRef.praticaDettagliData.value.numero_repertorio, dataRef.praticaDettagliData.value.suffisso_repertorio);
          break;

        case "numero_raccolta_completo":
          dataRef.praticaDettagli.value['numero_raccolta_completo'].value = calcNumeroRaccoltaCompleto(dataRef.praticaDettagliData.value.numero_raccolta, dataRef.praticaDettagliData.value.suffisso_raccolta);
          break;

        case "codice_identificativo_completo":
          dataRef.praticaDettagli.value['codice_identificativo_completo'].value = `${dataRef.praticaDettagliData.value.codice_identificativo}/${dataRef.praticaDettagliData.value.anno_identificativo ? dataRef.praticaDettagliData.value.anno_identificativo : '-'}`;
          break;
      }
      if (
        (dataRef.praticaDettagliData.value)[praticaKey] !== undefined &&
        (dataRef.praticaDettagliData.value)[praticaKey] != null
      ) {
        dataRef.praticaDettagli.value[praticaKey].value = (dataRef.praticaDettagliData.value)[praticaKey];
        dataRef.praticaDettagli.value[praticaKey].novalidate = true;

        if(praticaKey === 'data_creazione') {
          let data_creazione = dataRef.praticaDettagliData.value[praticaKey].split(' ');
          dataRef.praticaDettagli.value['data_creazione'].value = data_creazione[0];
        }
      }
    }

    dataRef.praticaDettagli.value['pratica_id'] = {};
    dataRef.praticaDettagli.value['pratica_id'].value = (dataRef.praticaDettagliData.value).pratica_id;
  }

  /**
   * TODO: togliere dataRef
   * Eseguito dopo il post del form del dettagli pratica
   * @param event
   * @param data
   * @param formData
   * @param goNext
   * @param praticaTabsInstance
   */
  function dopoAggiornamentoDettagliPratica(event, data, formData, goNext, praticaTabsInstance) {
    dataRef.praticaDettagliDefault.value = cloneDeep(dataRef.praticaDettagli.value);

    dataRef.intestazione.value.notaio_nome = formData.notaio_nome.value;
    dataRef.intestazione.value.descrizione = formData.descrizione.value;
    dataRef.praticaDettagliData.value.natura_atto = dataRef.praticaDettagli.value.natura_atto.value;

    dataRef.intestazione.value.numero_repertorio_completo = calcNumeroRepertorioCompleto(formData.numero_repertorio.value, formData.suffisso_repertorio.value);
    if (goNext) {
      praticaTabsInstance.toggle('soggetti')
      if(dataRef.modaleControlloTabIsChangeHash.value) {
        window.location.hash = 'soggetti'
      }
      if (dataRef.modaleControlloModificheDettagliPratica) {
        dataRef.modaleControlloModificheDettagliPratica.value = false;
      }
      dataRef.modaleControlloTabRef.value = '';
      dataRef.modaleControlloTabIsChangeHash.value = false;
    }
  }

  /**
   * @param tab
   * @param isChangeHash
   */
  function assegnaTabDaVerificare(tab, isChangeHash) {
    praticaStore.isDettagliPraticaModaleControlloModifiche = true;
    dataRef.modaleControlloTabRef.value = tab.controls;
    dataRef.modaleControlloTabIsChangeHash.value = isChangeHash;
  }

  /**
   * @param esito
   * @param praticaTabsInstance
   */
  function vaiATabDopoVerifica(esito, praticaTabsInstance) {
    if(esito) {
      if(dataRef.modaleControlloTabRef.value != '') praticaTabsInstance.toggle(dataRef.modaleControlloTabRef.value)
      if(dataRef.modaleControlloTabIsChangeHash.value) {
        let queryParams = cloneDeep(route.query)
        queryParams['azioni'] = dataRef.modaleControlloTabRef.value
        router.push({name: (window.location.pathname).replace('/',''), query: queryParams});
      }
      praticaStore.isDettagliPraticaModaleControlloModifiche = false;
      dataRef.modaleControlloTabRef.value = '';
      dataRef.modaleControlloTabIsChangeHash.value = false;
    }
  }

  /**
   * Metodo che serve per sincronizzare i v-model del dettagli pratica fragment
   * @param dati
   */
  const sincronizzaDatiDettaglioPratica = (dati) => dataRef.praticaDettagli.value = dati;

  return {
    getNaturaAtti,
    popolaDettagliPratica,
    dopoAggiornamentoDettagliPratica,
    assegnaTabDaVerificare,
    vaiATabDopoVerifica,
    sincronizzaDatiDettaglioPratica
  }
}